import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router,private toster:ToasterService) {}

  ngOnInit(): void {}
  /* logOut() {
    this.authService.logout();  
  } */
}
